<template>
  <el-row :gutter="16">

    <el-col :span="24">
      <div v-if="site.latitude && site.longitude">
        <google-map :lat="site.latitude" :lng="site.longitude" :zoom="16" type="hybrid" />
      </div>
      <div v-else>
        <h3>No mapping data found</h3>
      </div>
    </el-col>

    <el-col :span="24">
      <div style="padding: 14px;">
        <el-col :span="16">
          <p v-if="site.siteName"><strong>{{site.siteName}}</strong>&nbsp;<small>{{ site.siteId }}</small>&nbsp;
            <span v-if="site.subdistrict"><i>|&nbsp;{{site.subdistrict}}</i>
              <i v-if="site.district"><span v-if="site.subdistrict">, </span>{{site.district}}</i>
              <i v-if="site.region"><span v-if="site.district || site.subdistrict">, </span>{{site.region}}</i>
              <i v-if="site.state"><span v-if="site.district || site.subdistrict || site.region">, </span>{{site.state}}</i>
              <i v-if="site.country"><span v-if="site.district || site.subdistrict || site.region || site.state">, </span>{{site.country}}</i></span>
          </p>
        </el-col>
        <el-col v-if="site.sharers" :span="24">
          <span class="text-muted">Sharers: </span><span><strong>{{site.sharers}}</strong></span>
        </el-col>
        </div>
    </el-col>
  </el-row>
</template>

<script>

import GoogleMap from '@/components/atoms/GoogleMap'

export default {

  components: {
    GoogleMap
  },


  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      site: this.rowData.site
    }
  }   // data

}

</script>



// WEBPACK FOOTER //
// SiteMap.vue?3c1fa822